import {classNames, React, useEffect, useHotkeys, observer} from '@api'
import {useCatalogItemSidebarDetailsStore} from '@design-board/stores'
import {CatalogItemModalHeader, CatalogItemModalDetailTabs, ModalDetailNotes, DetailsModalNavToolbar} from './'
import * as css from './CatalogDetailsModal.css'
import {Icon, Portal} from '@blueprintjs/core'
import { site, useCatalog} from '@stores'
import {CatalogNavigationButtons} from './CatalogNavigationButtons'
import {CatalogItemImageCarousel} from '@lazy'

export const CatalogItemModelContents = observer<React.HTMLProps<HTMLDivElement>>(function CatalogItemModelContents({className, ...props}) {
  const store = useCatalogItemSidebarDetailsStore(),
    {data, detailDef: {modal}, orientation, selectedDetailTab, sidebar, presentationMode, onTogglePresentationMode, flexLayout: {isMaximized}, stores} = store,
    catalog = useCatalog()

  useHotkeys('up', () => {
    const {modal: {carousel: {navigateToPreviousCarouselItem}}} = store

    navigateToPreviousCarouselItem()
  })

  useHotkeys('down', () => {
    const {modal: {carousel: {navigateToNextCarouselItem}}} = store

    navigateToNextCarouselItem()
  })

  useHotkeys('p', e => {
    if (!site.isShowingPopover) {
      onTogglePresentationMode()
    }
  })

  useEffect(() => {
    if (catalog.index === store.index) {
      const {groupBy: {lastGroupInHierarchy}} = catalog
      catalog.focusedCatalogItemId = store.props.idWithPath ?? `${lastGroupInHierarchy?.focusedGroup ? `${lastGroupInHierarchy.focusedGroup.store.pathLookup}.`: ''}${data?._id}`
    }
  }, [store.props.idWithPath, data?._id])

  //console.log({data: toJS(data), detailDef: toJS(detailDef)})
  return (
    <div className={classNames(css.root, className)}
         {...props}
         tabIndex={0}
         data-type='CatalogItemModal'
         data-modal={true}
         data-has-notes={modal?.notes != null}
         data-selected-image-index={sidebar?.details?.modal?.carousel?.selectedImageIndex ?? -1}
         data-presentation={presentationMode}
         data-orientation={orientation}
         >
      {isMaximized && stores.purpose !== 'inline-details' ? <Portal><CatalogNavigationButtons/></Portal> : null}

      {isMaximized && <DetailsModalNavToolbar />}
      <CatalogItemModalHeader />
      {!selectedDetailTab?.template && <CatalogItemImageCarousel orientation='horizontal'/>}
      <CatalogItemModalDetailTabs/>

      {modal?.notes && <ModalDetailNotes/>}

      {/*<CatalogItemPrimaryDetails />*/}


      {/*<div data-grid-area='secondary'>*/}
      {/*  {detailDef.sections.filter(s => !s.name).map((section, i) => <SidebarSection align='modal' key={i} section={section}/>)}*/}
      {/*  {detailDef.sections.filter(s => s.name).map((section, i) => <SidebarSection align='modal' key={i} section={section}/>)}*/}
      {/*</div>*/}

      {/*<div data-grid-area='whitespace' />*/}

      {/*<div data-grid-area='specs'>*/}
      {/*  <h1>Data Sheets</h1>*/}
      {/*</div>*/}

      {/*<div data-grid-area='vendor'>*/}
      {/*  <h1>Vendor Product</h1>*/}
      {/*</div>*/}

      {/*<div data-grid-area='ratings'>ratings</div>*/}

      {/*<CatalogItemComments data-grid-area='comments' />*/}
    </div>)
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/CatalogDetailsModal.tsx